import * as texture from "./texture.jsx";
import * as hud from "./hud.jsx";
import action from "./action.jsx";
import object from "./object.jsx";
import avatar from "./avatar.jsx";
import event from "./event.jsx";
import queue from "./queue.jsx";
import scene from "./scene.jsx";
import zone from "./zone.jsx";
import world from "./world.jsx";
import sprite from "./sprite.jsx";
import tileset from "./tileset.jsx";
import speech from "./speech.jsx";
import dispatcher from "./dispatcher.jsx";

export default {
  action,
  avatar,
  object,
  event,
  queue,
  scene,
  texture,
  hud,
  dispatcher,
  tileset,
  speech,
  zone,
  world,
  sprite,
};
